import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";

@Component({
    selector: "adapt-clf-page",
    templateUrl: "./clf-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CulturalLeadershipFrameworkPageComponent extends BaseRoutedComponent implements OnInit {
    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}
